import eventTextStore, { DefaultEventTextStore } from 'pages/SystemSettings/DefaultEventText/DefaultEventTextStore';
import caseEventCategoryStore, { CaseEventCategoryStore } from 'pages/SystemSettings/CaseEventCategories/caseEventCategories';
import ruleStore, { RuleStore } from 'pages/SystemSettings/Rules/rules';
import appSettingsStore, { AppSettingsStore } from 'pages/SystemSettings/AppSettings/appsettings';
import requestLedgerSubCategoriesStore, { RequestLedgerSubCategoriesStore } from 'pages/SystemSettings/RequestLedgerSubCategoriesPage/requestLedgerSubCategories';

export interface AllStores {
    eventTextStore: DefaultEventTextStore;
    caseEventCategoryStore: CaseEventCategoryStore;
    ruleStore: RuleStore;
    appSettingsStore: AppSettingsStore;
    requestLedgerSubCategoriesStore: RequestLedgerSubCategoriesStore;
}

const allStores = {
    eventTextStore,
    caseEventCategoryStore,
    ruleStore,
    appSettingsStore,
    requestLedgerSubCategoriesStore
}

export default allStores;